import { AntibiotsMicrobiologyInfo, GrnRequest } from "@gtpl/shared-models/raw-material-procurement";
import { CommonResponse } from "@gtpl/shared-models/masters";
import axios from 'axios';
import connection from "./connection";

export class AntiBioticsReportService{

    URL = connection.DEPLOY_URL+'/rm-antibiotics-report';

    async createAntibioticsInfo(data: any): Promise<CommonResponse>{
       return await axios.post(this.URL+ '/createAntibioticsInfo', data)
           .then(res => {
               return res.data
           })
    }

    async revertAntiBioticsTestStatus(data: any): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/revertAntiBioticsTestStatus', data)
            .then(res => {
                return res.data
            })
     }

    async getAllAntiBioticsResult(req: any): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsResult', req)
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsPreHarvestData(req:any): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsPreHarvestData',req)
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsGradingData(req:any): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsGradingData',req)
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsRejectedIndentsData(req:any): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsRejectedIndentsData',req)
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsFailedGrnNumbers(): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsFailedGrnNumbers')
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsFailedCount(): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsFailedCount')
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsFailedFarmer(): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsFailedFarmer')
            .then(res => {
                return res.data
            })
     }

     async getAllAntiBioticsFailedIndentsNumbers(): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/getAllAntiBioticsFailedIndentsNumbers')
            .then(res => {
                return res.data
            })
     }

     async updateAntiBioticTest(req: any): Promise<CommonResponse>{
        return await axios.post(this.URL+ '/updateAntiBioticTest', req)
            .then(res => {
                return res.data
            })
     }
 }
